import { pathOr } from 'ramda';

import { IState } from '../../store';

export function getNewbuildingId(state: IState): number | null {
  return pathOr(null, ['offerData', 'newObject', 'id'], state);
}
